import Header from '@core/components/Header';
import Auth from '@utils/helpers/auth';
import { useEffect, useMemo, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { IntlProvider } from 'react-intl';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import Layout from '@root/core/components/Layout';
import Routes from '@core/components/Init/Routes';
import { defaultResource } from '@root/core/constants/resource';
import configureStore from '@store/configureStore';
import LocaleContext from '@utils/contexts/Locale';
import ResourceContext from '@utils/contexts/Resource';
import Resource from '@utils/helpers/resource';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { CURRENT_ENV } from './core/configs/env';
import ProductProvider from './modules/Sellers/provider/ProductProvider';
import { storeRedux } from './state';
import ChangePass from './modules/Authentication/ForgotPass/pages/ChangePass';
import ForgotPass from './modules/Authentication/ForgotPass/pages/ForgotPass';

export const [store, persistor] = configureStore();

const App = () => {
  const [resource, setResource] = useState(defaultResource);
  const [locale, setLocale] = useState(localStorage.getItem('lang') || 'ko');
  const history = useHistory();
  const location = useLocation();
  const appRole = CURRENT_ENV.APP_ROLE;
  function getCookie(name: string) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts?.pop()?.split(';')?.shift();
    return null;
  }
  console.log(getCookie('JSESSIONID'), 'cookie');
  console.log(appRole, 'appRole');
  const [isReset, setIsReset] = useState(false);

  const authenticated = Auth.authenticated();
  const resetRoutes = () => {
    setPageContext();
    setResourceContext();
    store.runSaga([]);
  };
  useEffect(() => {
    resetRoutes();
    localStorage.setItem('lang', 'ko');
  }, [authenticated]);

  const setResourceContext = () => {
    return Resource.init(authenticated).then((resource) => {
      setResource(resource);
    });
  };

  useEffect(() => {
    const setShareToken = (event: MessageEvent) => {
      // console.log('receive ===>', event.origin);
      // console.log('current web url ===>', CURRENT_ENV.WEB_URL);

      if (event.origin !== 'https://buskinc.com') return;
      if (event.data) Auth.setToken(JSON.parse(event.data));
    };
    window.addEventListener('message', setShareToken);
    return () => window.removeEventListener('message', setShareToken);
  }, []);

  const setPageContext = () => {
    const currentPath = location.pathname;

    let loginUrl = '/admin/login';
    let dashboardUrl = '/admin/login';

    setIsReset(location.pathname.includes('reset-password' || 'find-password'));

    switch (appRole) {
      case 'seller-admin':
        loginUrl = '/admin/login';
        dashboardUrl = '/admin/seller';
        break;

      case 'warehouse-admin':
        loginUrl = '/admin/login-warehouse';
        dashboardUrl = '/admin/warehouse';
        break;

      case 'forwarder-admin':
        loginUrl = '/admin/login-forwarder';
        dashboardUrl = 'admin/forwarder';
        break;

      case 'seller-api':
        loginUrl = '/admin/login-seller-api';
        dashboardUrl = '/admin/seller-api';
        break;
      case 'warehouse-api':
        loginUrl = '/admin/login-warehouse-api';
        dashboardUrl = '/admin/warehouse-api';
        break;

      default:
        loginUrl = '/admin/login-busk';
        dashboardUrl = '/admin/busk';
        break;
    }
    const isLoginPage = location.pathname.includes(loginUrl);
    if (authenticated && (isLoginPage || location.pathname === '/')) {
      return history.push(dashboardUrl);
    }
    const isUnAuthenticatedRoute = resource.routes.filter((route) =>
      route.path.includes(currentPath)
    );

    if (currentPath === '/' && !authenticated) {
      return history.push(loginUrl);
    } else if (!authenticated && isUnAuthenticatedRoute.length > 0)
      return history.push(currentPath);
  };

  const setLocaleContext = (locale: string) => {
    setLocale(locale);
  };

  const title = useMemo(() => {
    if (appRole === 'seller-admin') {
      return 'Seller WMS';
    } else if (appRole === 'warehouse-admin') {
      return 'Warehouse WMS';
    } else if (appRole === 'forwarder-admin') {
      return 'Forwarder WMS';
    } else if (appRole === 'seller-api') {
      return 'Seller API';
    } else if (appRole === 'warehouse-api') {
      return 'Warehouse API';
    }
    return 'Busk Admin';
  }, [appRole]);

  console.log(resource.authenticated, 'resource');

  return resource.initiated ? (
    <Provider store={store}>
      <Provider store={storeRedux}>
        <PersistGate loading={null} persistor={persistor}>
          <HelmetProvider>
            <Helmet>
              <title>{title}</title>
            </Helmet>
            <IntlProvider
              locale={locale}
              messages={resource.message[locale]}
              onError={(e) => {}}
            >
              <ResourceContext.Provider
                value={{ resource, setResourceContext }}
              >
                <LocaleContext.Provider value={{ locale, setLocaleContext }}>
                  <ProductProvider>
                    <div className="app">
                      {/* {appRole == "warehouse-admin" ? null : ( */}
                      {!isReset && (
                        <Header
                          appRole={appRole}
                          authenticated={resource.authenticated}
                        />
                      )}
                      {/* )} */}
                      {!isReset && (
                        <Layout
                          authenticated={resource.authenticated}
                          content={
                            <Routes
                              routes={resource.routes}
                              authenticated={resource.authenticated}
                            />
                          }
                        />
                      )}

                      {!resource.authenticated && (
                        <Routes
                          routes={resource.routes}
                          appRole={appRole}
                          authenticated={resource.authenticated}
                        />
                      )}
                    </div>
                    <Switch>
                      <Route path="/admin/reset-password/:token">
                        <ChangePass />
                      </Route>
                      <Route path="/admin/find-password">
                        <ForgotPass />
                      </Route>
                    </Switch>
                  </ProductProvider>
                </LocaleContext.Provider>
              </ResourceContext.Provider>
            </IntlProvider>
          </HelmetProvider>
        </PersistGate>
      </Provider>
    </Provider>
  ) : (
    <div>Loading...</div>
  );
};

export default App;
